import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { JourneyPage } from "@/journey/JourneyPage";
import { Toaster } from "sonner";
import "@/App.css";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Countdown } from "@/components/Countdown";
import { Chapters } from "@/components/Chapters";
import { AqiqahStory } from "@/components/AqiqahStory";
import { Invitation } from "@/components/Invitation";
import { InviteCard } from "@/components/InviteCard";
import { CursorSparkles } from "@/components/CursorSparkles";
import { GamesHub } from "@/components/GamesHub";
import { WishesWall } from "@/components/WishesWall";
import { Footer } from "@/components/Footer";

const Home = () => (
  <div className="noise-overlay bg-[#070814] min-h-screen" data-testid="fairytale-app">
    <Toaster theme="dark" position="top-center" toastOptions={{ style: { background: "#141127", border: "1px solid rgba(243,229,171,0.25)", color: "#f3e5ab" } }} />
    <CursorSparkles />
    <Navbar />
    <main>
      <Hero />
      <Marquee />
      <Countdown />
      <Chapters />
      <AqiqahStory />
      <Invitation />
      <InviteCard />
      <Marquee />
      <GamesHub />
      <WishesWall />
    </main>
    <Footer />
  </div>
);

const LenisGate = ({ children }) => {
  const isJourney = useLocation().pathname.startsWith("/journey");
  useEffect(() => {
    if (isJourney) return;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, [isJourney]);
  return children;
};

function App() {
  return (
    <BrowserRouter>
      <LenisGate>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/journey" element={<JourneyPage />} />
        </Routes>
      </LenisGate>
    </BrowserRouter>
  );
}

export default App;
